import React from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import PersonalHistory from "./PersonalHistory";
import MedicalHistory from "./MedicalHistory";
import BackNext from "../../Common/SubComponents/BackNext";
import { Row, Col, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object } from 'yup';
import { getBasicInfo, setBasicInfo } from "../../../../sessionStorage";

export default function PersonalMedicalHistory(props) {
    const { fullFormState, basicInfo, onFieldChange, onMultiFieldChange } = props;

    const formMethods = useForm({
        resolver: yupResolver(PersonalMedicalHistory.ValidationSchema(props.isPartnerLoanProtection)),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: { ...fullFormState.steps.personalHistory, ...fullFormState.steps.medicalHistory },
    });

    const { register, handleSubmit, setValue, trigger } = formMethods;

    const submitForm = () => {
        if (props.isPartnerLoanProtection) {
            const basicInfo = getBasicInfo();
            const formState = { ...fullFormState };
            const medicalHistory = fullFormState.steps.medicalHistory;
            //set height and weight in the basicInfo formState and basicInfo session for partner loan protection.
            formState.steps.basicInfo.height = basicInfo.height = medicalHistory.height;
            formState.steps.basicInfo.weight = basicInfo.weight = medicalHistory.weight;
            onMultiFieldChange(fullFormState);
            setBasicInfo(basicInfo);
        }
        props.onNext();
    };

    return (
        <Container>
            <FormProvider {...formMethods}>
                <form className="quote-form" onSubmit={handleSubmit(submitForm)}>
                    <Row className='formPage justify-content-center'>
                        <Col lg={6}>
                            <PersonalHistory
                                formState={fullFormState.steps.personalHistory}
                                onFieldChange={(field, value) => onFieldChange('personalHistory', field, value)}
                                basicInfo={basicInfo}
                                register={register}
                                setValue={setValue}
                                trigger={trigger}
                            />
                            <MedicalHistory
                                formState={fullFormState.steps.medicalHistory}
                                onFieldChange={(field, value) => onFieldChange('medicalHistory', field, value)}
                                basicInfo={basicInfo}
                                fullFormState={fullFormState}
                                onMultiFieldChange={onMultiFieldChange}
                                register={register}
                                setValue={setValue}
                                trigger={trigger}
                                showHeightAndWeight={props.isPartnerLoanProtection} // For partner loan protection, display the height and weight fields on the medical history page. 
                            />
                        </Col>
                    </Row>
                    <BackNext onBack={props.onBack} colSize={2} width={100} continueLabel={{ text: 'Next' }} />
                </form>
            </FormProvider>
        </Container>
    );
}

PersonalMedicalHistory.ValidationSchema = (showHeightAndWeight) => object().shape({ ...PersonalHistory.ValidationSchema.fields, ...MedicalHistory.ValidationSchema(showHeightAndWeight).fields });

PersonalMedicalHistory.propTypes = {
    fullFormState: PropTypes.object,
    onFieldChange: PropTypes.func,
    onMultiFieldChange: PropTypes.func,
    basicInfo: PropTypes.object
};
